module.exports = __webpack_public_path__ + "img/LogoFooter.ab7b1a33.svg";